import { type ChallengeDefinition, type ChallengeScale, FESTIVAL } from '../../data/full/festival';
import { compound } from '../effects';
import type { EnemyScale } from '../state';

export function heldScale(held: number): EnemyScale | undefined {
  if (held === 0) {
    return undefined;
  }
  const { hp, damage } = FESTIVAL.perStageHeld;
  return { hp: compound(hp, held), damage: compound(damage, held) };
}

export function challengeOf(id: string): ChallengeDefinition {
  const challenge = FESTIVAL.challenges.list.find((candidate) => candidate.id === id);
  if (challenge === undefined) {
    throw new Error(`unknown challenge: "${id}"`);
  }
  return challenge;
}

const SCALED: readonly (keyof ChallengeScale)[] = ['speed', 'count', 'bossHp', 'bossDamage'];

// What the stages held and the challenges taken on the way give the bad vibes of a stage.
export function stageScale(held: number, challengeIds: readonly string[]): EnemyScale | undefined {
  const base = heldScale(held);
  if (challengeIds.length === 0) {
    return base;
  }
  const scale: EnemyScale = base ?? { hp: 1, damage: 1 };
  for (const id of challengeIds) {
    const challenge = challengeOf(id);
    for (const key of SCALED) {
      const factor = challenge.scale[key];
      if (factor !== undefined) {
        scale[key] = (scale[key] ?? 1) * factor;
      }
    }
  }
  return scale;
}

// What the stage ahead earns, taken these challenges.
export function challengeScoreMul(challengeIds: readonly string[]): number {
  return challengeIds.reduce((mul, id) => mul + challengeOf(id).score, 1);
}
